import { render } from "./CancellationPolicy.vue?vue&type=template&id=162c79a6"
import script from "../js/cancellation-policy.js?vue&type=script&lang=js&external"
export * from "../js/cancellation-policy.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__